import styled from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { CardGrid } from '../../CardGrid';

type CtaWrapperProps = {
  isVisibleDesktop: boolean;
  isVisibleMobile: boolean;
};

export const CtaWrapper = styled.div<CtaWrapperProps>`
  display: ${({ isVisibleMobile }) => (isVisibleMobile ? 'flex' : 'none')};
  ${({ isVisibleDesktop }) =>
    mediaQuery.tabletLandscape`
    display: ${isVisibleDesktop ? 'flex' : 'none'};
  `}
  justify-content: center;

  margin-bottom: ${spacing(4)};
`;

export const InitialDisplayCardGrid = styled(CardGrid)`
  ${mediaQuery.tabletLandscape`
    /* Standardise top spacing to 8px so it will sit next to other components nicely */
    margin-top: ${spacing(-1)};

    /* Hide the duplicated card on desktop, see comment on RelatedContentWithVisibilityToggle component */
    > *:nth-child(4) {
      display: none;
    }
  `}
`;

export const CollapsibleCardGrid = styled(CardGrid)`
  /* Hide the duplicated card on mobile and tablet portrait, see comment on RelatedContentWithVisibilityToggle component */
  > *:first-child {
    display: none;
  }

  ${mediaQuery.tabletLandscape`
    > *:first-child {
      display: flex;
    }
  `}
`;
